// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const rnc: CountryValidator<"DO"> = createValidator(
  "do.rnc",
  59,
);

export default rnc;
export const compact = rnc.compact;
export const format = rnc.format;
export const validate = rnc.validate;
export const generate = (): string =>
  rnc.generate?.() ??
  (() => {
    throw new Error(
      "Validator do.rnc cannot generate values",
    );
  })();
